import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';
import appConfig from '@/appConfig';

export type SiderTheme = 'light' | 'dark';

dayjs.extend(utc);

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

// 顶部右侧时区展示组件，时间按秒实时更新
export const TimeZoneDisplay: React.FC = () => {
  const { timeZone } = appConfig as any;
  const [now, setNow] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(dayjs());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const offset = timeZone?.offset ?? -3;
  // 由 offset 推导出展示用的 code，避免多处维护
  const code = `UTC${offset >= 0 ? `+${offset}` : offset}`;
  const displayTime = now.utcOffset(offset).format('YYYY/MM/DD HH:mm:ss');

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginRight: 8,
        height: 40,
      }}
    >
      <span
        style={{
          fontSize: 32,
          marginRight: 8,
        }}
      >
        {timeZone?.timeZoneIcon}
      </span>
      <div
        style={{
          fontSize: 12,
          lineHeight: 1.2,
          color: '#000',
        }}
      >
        <div>{timeZone?.name ?? '巴西'}</div>
        <div style={{ display: 'flex', gap: 12 }}>
          <span>{code}</span>
          <span>{displayTime}</span>
        </div>
      </div>
    </div>
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
